<template>
  <!-- eslint-disable -->
  <div class="app-container">
    <div class="column-left">
      <SideNav />
    </div>

    <div class="column-right">
      <TopNav />

      <div class="main-container">
        <div v-if="aliasHorario.length > 0" class="alias-section">
          <h4>Alias existentes:</h4>
          <ul class="alias-list">
            <li v-for="alias in aliasHorario" :key="alias.id" class="alias-item">
              <div class="alias-content">
                <strong class="alias-name">{{ alias.nombre_alias }}</strong>
                <span v-if="alias.descripcion" class="alias-description">- {{ alias.descripcion }}</span>
              </div>
              <button @click="eliminarAlias(alias.id)" class="alias-delete-btn">
                <b-icon icon="trash" />
              </button>
            </li>
          </ul>
        </div>

        <!-- Formulario para crear nuevo alias -->
        <div class="alias-form">
          <h4>Crear nuevo alias</h4>
          <div class="form-group">
            <label class="form-label">Nombre del alias:</label>
            <input v-model="nuevoAlias.nombre" type="text" class="form-input" placeholder="Ingresa el nombre del alias">
          </div>
          <div class="form-group">
            <label class="form-label">Descripción (opcional):</label>
            <input v-model="nuevoAlias.descripcion" type="text" class="form-input" placeholder="Agrega una descripción">
          </div>
          <button :style="{ 'background-color': prestador.admin.assets.colors.primary }" class="btn btn-success add-alias-btn"
            @click="crearAlias">
            <b-icon icon="plus-circle" style="margin-right:6px;" />
            Agregar Alias
          </button>
        </div>
      </div>
      
      <div v-if="loaded" class="articulo-principal">
        <h2 class="page-title">Modificar horario id {{ $route.params.id }}</h2>
        <div class="boxy">
          <!-- Sección de características del horario -->
          <div class="schedule-grid">

            <div class="schedule-column main-settings">
              <div v-if="prestador.id !=16" class="setting-group">
                <label class="setting-label">
                  Intervalo
                  <div class="info-icon-container">
                    <i :style="{ 'color': prestador.admin.assets.colors.primary }"
                      class="info-icon action-icon tf-icons ti ti-info-circle-filled"></i>
                    <div :style="{ 'background-color': prestador.admin.assets.colors.primary }"
                      class="info-icon-container-popup">
                      Intervalos de tiempo que durará las atenciones, y que será mostrado en la agenda.
                    </div>
                  </div>
                </label>
                <select v-model="periodo" class="form-select">
                  <option v-for="o in periodos_posibles" :value="o">
                    {{ o }} minutos
                  </option>
                </select>
              </div>
              
              <div class="time-settings-grid">
                <div class="time-setting">
                  <div class="setting-label">
                    Inicio
                    <div class="info-icon-container">
                      <i :style="{ 'color': prestador.admin.assets.colors.primary }"
                        class="info-icon action-icon tf-icons ti ti-info-circle-filled"></i>
                      <div :style="{ 'background-color': prestador.admin.assets.colors.primary }"
                        class="info-icon-container-popup">
                        Inicio de la agenda, primera hora que se mostrará.
                      </div>
                    </div>
                  </div>
                  <select v-model="agregando_horario.inicio" class="form-select">
                    <option v-for="v in Math.round(1440 / 5)" :value="(v - 1) * 5">
                      {{ timeConvert((v - 1) * 5) }}
                    </option>
                  </select>
                </div>
                
                <div class="time-setting">
                  <div class="setting-label">
                    Termino
                    <div class="info-icon-container">
                      <i :style="{ 'color': prestador.admin.assets.colors.primary }"
                        class="info-icon action-icon tf-icons ti ti-info-circle-filled"></i>
                      <div :style="{ 'background-color': prestador.admin.assets.colors.primary }"
                        class="info-icon-container-popup">
                        Término de la agenda, se mostrarán horas espaciadas por el intervalo seleccionado.
                      </div>
                    </div>
                  </div>
                  <select v-model="agregando_horario.termino" class="form-select">
                    <option v-for="v in Math.round((1440 - agregando_horario.inicio) / periodo)"
                      :value="(v) * periodo + agregando_horario.inicio">
                      {{ timeConvert((v) * periodo + agregando_horario.inicio) }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="days-section">
                <div class="setting-label">
                  Días de la semana
                  <div class="info-icon-container">
                    <i :style="{ 'color': prestador.admin.assets.colors.primary }"
                      class="info-icon action-icon tf-icons ti ti-info-circle-filled"></i>
                    <div :style="{ 'background-color': prestador.admin.assets.colors.primary }"
                      class="info-icon-container-popup">
                      Días para los cuales estará habilitado el horario.
                    </div>
                  </div>
                </div>
                <div class="days-grid">
                  <div v-for="(day, index) in dias" :key="index" class="day-item">
                    <label class="day-label">
                      <input v-model="agregando_horario.repeticion[index].value" 
                             type="checkbox" 
                             :true-value="1" 
                             :false-value="0"
                             class="day-checkbox">
                      <span class="day-text">{{ day }}</span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="setting-group">
                <label class="setting-label">
                  Solo se puede agendar hasta (días antes y hora):
                </label>
                <div class="time-range">
                  <select v-model="anticipacion_fija_minima_dias" class="form-select small">
                    <option v-for="day in [0, 1, 2, 3]" :value="day">
                      {{ day }} Días antes
                    </option>
                  </select>
                  <select v-model="anticipacion_fija_minima_hora" class="form-select small">
                    <option v-for="v in 25" :value="v - 1">
                      A las {{ timeConvert(((v - 1) * 60)) }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="setting-group">
                <label class="setting-label">
                  Solo se puede agendar desde (días antes y hora):
                </label>
                <div class="time-range">
                  <select v-model="disponible_desde_dias" class="form-select small">
                    <option v-for="day in [0, 1, 2, 3]" :value="day">
                      {{ day }} Días antes
                    </option>
                  </select>
                  <select v-model="disponible_desde_hora" class="form-select small">
                    <option v-for="v in 25" :value="v - 1">
                      A las {{ timeConvert(((v - 1) * 60)) }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="setting-group">
                <label class="setting-label">
                  Prioridad
                  <div class="info-icon-container">
                    <i :style="{ 'color': prestador.admin.assets.colors.primary }"
                      class="info-icon action-icon tf-icons ti ti-info-circle-filled"></i>
                    <div :style="{ 'background-color': prestador.admin.assets.colors.primary }"
                      class="info-icon-container-popup">
                      Horarios con mayor prioridad se mostrarán primero.
                    </div>
                  </div>
                </label>
                <select v-model="prioridad" class="form-select">
                  <option v-for="v in prioridades" :value="v">
                    {{ v }}
                  </option>
                </select>
              </div>

              <div class="checkbox-settings">
                <div class="checkbox-group">
                  <label class="checkbox-label">
                    <input v-model="genera_bloqueo" type="checkbox" class="checkbox-input">
                    <span class="checkbox-text">
                      Genera bloqueo
                      <div class="info-icon-container">
                        <i :style="{ 'color': prestador.admin.assets.colors.primary }"
                          class="info-icon action-icon tf-icons ti ti-info-circle-filled"></i>
                        <div :style="{ 'background-color': prestador.admin.assets.colors.primary }"
                          class="info-icon-container-popup">
                          Al activar esta opción, tomar una hora en este horario bloqueará completamente el resto.
                        </div>
                      </div>
                    </span>
                  </label>
                </div>

                <div class="checkbox-group">
                  <label class="checkbox-label">
                    <input v-model="fecha_inicio_checkbox" type="checkbox" class="checkbox-input">
                    <span class="checkbox-text">
                      Fecha inicio
                      <div class="info-icon-container">
                        <i :style="{ 'color': prestador.admin.assets.colors.primary }"
                          class="info-icon action-icon tf-icons ti ti-info-circle-filled"></i>
                        <div :style="{ 'background-color': prestador.admin.assets.colors.primary }"
                          class="info-icon-container-popup">
                          Fecha a partir de la cual el horario entra en vigencia.
                        </div>
                      </div>
                    </span>
                  </label>
                  <input v-if="fecha_inicio_checkbox" v-model="fecha_inicio_dt" type="date" class="form-input date-input">
                </div>

                <div class="checkbox-group">
                  <label class="checkbox-label">
                    <input v-model="fecha_termino_checkbox" type="checkbox" class="checkbox-input">
                    <span class="checkbox-text">
                      Fecha término
                      <div class="info-icon-container">
                        <i :style="{ 'color': prestador.admin.assets.colors.primary }"
                          class="info-icon action-icon tf-icons ti ti-info-circle-filled"></i>
                        <div :style="{ 'background-color': prestador.admin.assets.colors.primary }"
                          class="info-icon-container-popup">
                          Indica hasta qué fecha el horario es válido.
                        </div>
                      </div>
                    </span>
                  </label>
                  <input v-if="fecha_termino_checkbox" v-model="fecha_termino_dt" type="date" class="form-input date-input">
                </div>
              </div>

              <!-- SECCIÓN MEJORADA: Fechas específicas -->
              <div class="setting-group">
                <label class="checkbox-label large">
                  <input type="checkbox" v-model="solo_fechas_especificas" class="checkbox-input">
                  <span class="checkbox-text">Habilitar fechas específicas para este horario</span>
                </label>
              </div>
              
              <div v-if="solo_fechas_especificas" class="specific-dates-section">
  <!-- Primero los controles, luego el date picker -->
  <div class="dates-controls">
    <button :style="{ 'background-color': prestador.admin.assets.colors.primary }" 
            class="btn btn-success date-picker-btn"
            @click="openCalendar($event)">
      <b-icon icon="calendar" style="margin-right:6px;" />
      Seleccionar Fechas
    </button>
    
    <button v-if="chosenDates.length > 0" 
            class="btn btn-outline clear-dates-btn" 
            @click="clearAllDates">
      <b-icon icon="x-circle" style="margin-right:4px;" />
      Limpiar todas
    </button>
  </div>
  
  <!-- El MultiDatePicker se mantiene aquí pero se controla su visibilidad -->
  <MultiDatePicker v-model="chosenDates" ref="datePicker" :x="calendarX" :y="calendarY" />
  
  <div v-if="chosenDates.length > 0" class="selected-dates-section">
    <div class="dates-header">
      <strong>Fechas seleccionadas ({{ chosenDates.length }}):</strong>
      <small>Haz clic en una fecha para eliminarla</small>
    </div>
    <div class="selected-dates-grid">
      <div v-for="(date, index) in chosenDates" 
           :key="index" 
           class="date-badge interactive"
           @click="removeDate(index)"
           :title="'Click para eliminar: ' + formatDate(date)">
        {{ formatDate(date) }}
        <span class="remove-date">×</span>
      </div>
    </div>
  </div>
  
  <div v-else class="no-dates-message">
    <b-icon icon="calendar-x" style="margin-right:8px;" />
    No hay fechas seleccionadas. Haz clic en "Seleccionar Fechas" para agregar.
  </div>
</div>
            </div>

            <!-- Sección de Comunas y Categorías -->
            <div class="schedule-column secondary-settings">
              <div class="setting-group">
                <label class="setting-label">
                  Comunas
                  <div class="info-icon-container">
                    <i :style="{ 'color': prestador.admin.assets.colors.primary }"
                      class="info-icon action-icon tf-icons ti ti-info-circle-filled"></i>
                    <div :style="{ 'background-color': prestador.admin.assets.colors.primary }"
                      class="info-icon-container-popup">
                      Para cuáles comunas se mostrará este horario.
                    </div>
                  </div>
                </label>
                <div class="search-container">
                  <input v-model="comunas_buscadas" 
                         type="text" 
                         class="form-input search-input" 
                         placeholder="Buscar comuna...">
                  <div v-if="comunas_buscadas != ''" class="search-results">
                    <div v-for="r in resultado_fuse_comuna.slice(0, 10)" 
                         :key="r.item.id" 
                         class="search-result-item" 
                         @click="agregar_comunas(r.item.id)">
                      <span class="result-text">{{ r.item.Nombre }}</span>
                      <b-icon v-if="comunas_selected.includes(r.item.id)" 
                              icon="check" 
                              class="result-check" />
                    </div>
                  </div>
                </div>
                <div class="selected-items">
                  <div v-for="c in comunas_selected" 
                       :key="c" 
                       class="selected-item">
                    <span>{{ comunas.filter(x => x.id == c)[0].Nombre }}</span>
                    <button @click="removeComuna(c)" 
                            class="remove-item-btn"
                            title="Eliminar comuna">
                      ×
                    </button>
                  </div>
                </div>
              </div>

              <div class="setting-group">
                <label class="setting-label">
                  Categorías
                  <div class="info-icon-container">
                    <i :style="{ 'color': prestador.admin.assets.colors.primary }"
                      class="info-icon action-icon tf-icons ti ti-info-circle-filled"></i>
                    <div :style="{ 'background-color': prestador.admin.assets.colors.primary }"
                      class="info-icon-container-popup">
                      Este horario será visible para los pacientes con servicios asociados a las siguientes categorías.
                    </div>
                  </div>
                </label>
                <div class="table-container">
                  <table class="schedule-table">
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Nombre</th>
                        <th>Habilitado</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="categorias_usadas.includes(c.id)" 
                          v-for="c in editando_categorias" 
                          :key="c.id">
                        <td>{{ c.id }}</td>
                        <td>{{ c.nombre }}</td>
                        <td>
                          <label class="checkbox-label small">
                            <input v-model="c.puede" type="checkbox" class="checkbox-input">
                            <span class="checkbox-custom"></span>
                          </label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <!-- Botones de guardar/eliminar -->
          <div class="action-buttons">
            <button :style="{ 'background-color': prestador.admin.assets.colors.primary }" 
                    class="btn btn-success save-btn"
                    @click="agregar_horario(profesional.id, agregando_horario.inicio, agregando_horario.termino, agregando_horario.repeticion); crearAlias()">
              <b-icon icon="check-circle" style="margin-right:6px;" />
              Guardar Horario
            </button>
            <button class="btn btn-danger delete-btn" 
                    @click="eliminar_horario($route.params.id)">
              <b-icon icon="trash" style="margin-right:6px;" />
              Eliminar horario
            </button>
          </div>
        </div>

        <!-- Sección de atención a prestadores -->
        <div class="boxy prestadores-section">
          <h4 class="section-title">
            <b-icon icon="people" style="margin-right:8px;" />
            Atención a prestadores
          </h4>
          <div class="prestadores-content">
            <div class="table-container">
              <table class="schedule-table">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nombre</th>
                    <th>Habilitado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="prestador in prestadores_filtrados" :key="prestador.id">
                    <td>{{ prestador.id }}</td> 
                    <td>{{ prestador.nombre }}</td>
                    <td>
                      <label class="checkbox-label small">
                        <input v-model="prestador.activo" type="checkbox" class="checkbox-input">
                        <span class="checkbox-custom"></span>
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="prestadores-actions">
              <button :style="{ 'background-color': prestador.admin.assets.colors.primary }" 
                      class="btn btn-success"
                      @click="post_atencion_horario_prestador()">
                <b-icon icon="save" style="margin-right:6px;" />
                Guardar cambios de atención a prestadores
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Loader mientras se carga -->
      <div v-else class="articulo-principal">
        <div class="loader-container">
          <Loader :height="100" :width="100" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import Fuse from 'fuse.js';
import { mapGetters, mapActions } from 'vuex';
import SideNav from '@/components/SideNav.vue';
import InputColorPicker from 'vue-native-color-picker';
import Loader from '@/components/Loader.vue';
import TopNav from '@/components/TopNav.vue';
import MultiDatePicker from "./MultiDatePicker.vue";

export default {
  name: 'HelloWorld',
  components: {
    MultiDatePicker,
    InputColorPicker,
    TopNav,
    SideNav,
    Loader,
  },
  props: ['id'],
  data() {
    return {
      profesional: {},
      agregando_horario: {
        inicio: -1,
        termino: -1,
        repeticion: [
          { value: 0 },
          { value: 0 },
          { value: 0 },
          { value: 0 },
          { value: 0 },
          { value: 0 },
          { value: 0 }
        ]
      },
      dias: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Dom'],
      dias2: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sabado', 'Domingo'],
      periodo: 60,
      periodos_posibles: [15, 30, 45, 60, 90, 120, 180, 240, 300, 360],
      loaded: false,
      comunas_selected: [],
      resultado_fuse_comuna: [],
      comunas_buscadas: '',
      color: '#000000',
      anticipacion: 0,
      anticipacion_minima: 0,
      anticipacion_autoconfirmacion: 0,
      anticipacion_fija_minima_dias: 0,
      anticipacion_fija_minima_hora: 0,
      disponible_desde_dias: 0,
      disponible_desde_hora: 0,
      nombre: '',
      editando_examenes: [],
      editando_categorias: [],
      genera_bloqueo: false,

      fecha_inicio_checkbox: false,
      fecha_termino_checkbox: false,
      fecha_inicio_dt: '',
      fecha_termino_dt: '',

      // Variables para fechas específicas
      solo_fechas_especificas: false,
      chosenDates: [],        // Array de strings "YYYY-MM-DD"
      calendarVisible: false,
      calendarX: 120,
      calendarY: -100,

      prioridades: [1, 2, 3, 4, 5],
      prioridad: 1,
      recargo_porcentaje: 0,
      recargo_suma: 0,
      recargos: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100],
      prestadores_activos: [],
      prestadores: [],

      atiende_prestadores: [],

      aliasHorario: [],
      nuevoAlias: {
        nombre: '',
        descripcion: ''
      }
    }
  },
  created() {
    this.initialize_(this.$route.params.id);
    this.profesional_id = this.$route.params.profesional_id;
    this.get_atencion_profesional_prestador(this.profesional_id)
  },
  methods: {
    ...mapActions(['initialize']),
    cargarAliasHorario() {
      axios.get(window.hostname + `/api/admin/horario/${this.$route.params.id}/alias`)
        .then(response => {
          this.aliasHorario = response.data.alias;
        })
        .catch(error => {
          console.error("Error cargando alias:", error);
          this.$notify({
            duration: 5000,
            title: 'Error!',
            text: 'No se pudieron cargar los alias del horario',
            type: 'error'
          });
        });
    },

    // Crear un nuevo alias
    crearAlias() {
      if (!this.nuevoAlias.nombre) {
        this.$notify({
          duration: 5000,
          title: 'Error!',
          text: 'Debes ingresar un nombre para el alias',
          type: 'error'
        });
        return;
      }

      axios.post(window.hostname + '/api/admin/horario/alias', {
        horario_id: this.$route.params.id,
        nombre_alias: this.nuevoAlias.nombre,
        descripcion: this.nuevoAlias.descripcion
      })
        .then(response => {
          this.$notify({
            duration: 5000,
            title: 'Éxito!',
            text: 'Alias creado correctamente',
            type: 'success'
          });
          this.nuevoAlias = { nombre: '', descripcion: '' };
          this.cargarAliasHorario();
        })
        .catch(error => {
          console.error("Error creando alias:", error);
          this.$notify({
            duration: 5000,
            title: 'Error!',
            text: error.response?.data?.error || 'Error al crear el alias',
            type: 'error'
          });
        });
    },
     eliminarAlias(aliasId) {
    if (!confirm('¿Estás seguro de que deseas eliminar este alias?')) {
      return;
    }

    axios.delete(window.hostname + `/api/admin/horario/alias/${aliasId}`)
      .then(response => {
        this.$notify({
          duration: 5000,
          title: 'Éxito!',
          text: 'Alias eliminado correctamente',
          type: 'success'
        });
        this.cargarAliasHorario();
      })
      .catch(error => {
        console.error("Error eliminando alias:", error);
        this.$notify({
          duration: 5000,
          title: 'Error!',
          text: error.response?.data?.error || 'Error al eliminar el alias',
          type: 'error'
        });
      });
  },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const parts = dateStr.split('-');
      if (parts.length !== 3) return dateStr;
      // Retorna en el formato dd-mm-yyyy
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    },
    agregar_comunas(cid) {
      this.comunas_buscadas = '';
      if (!this.comunas_selected.includes(cid))
        this.comunas_selected.push(cid);
      else
        this.comunas_selected.splice(this.comunas_selected.indexOf(cid), 1);
    },
    openCalendar(event) {
      // Abre el componente MultiDatePicker (se puede ajustar la posición si se desea)
      this.$refs.datePicker.open();
    },
    timeConvert2(n) {
      const hours = Math.floor(n / 60);
      const minutes = Math.round(n % 60);
      return `${hours} h ${minutes} m.`;
    },
    modificar_anticipacion() {
      axios.post(window.hostname + '/api/admin/modificar_anticipacion', {
        profesional_id: this.profesional.id,
        anticipacion: this.anticipacion
      })
        .then(response => {
          this.initialize_(this.$route.params.id);
          this.initialize();
        })
        .catch((e) => console.log("Error al cargar..."));
    },
    cambiarPuedeCategorias() {
      let ret = [];
      for (let i = 0; i < this.categorias.length; i++) {
        if (
          this.profesional.categorias.some(x => x === this.categorias[i].id) !==
          this.editando_categorias.filter(x => x.id === this.categorias[i].id)[0].puede
        ) {
          ret.push({
            id: this.categorias[i].id,
            puede: this.editando_categorias.filter(x => x.id === this.categorias[i].id)[0].puede
          });
        }
      }
      axios.post(window.hostname + '/api/admin/modificar_categorias_pro', {
        id: this.profesional.id,
        categorias: ret
      })
        .then(response => {
          this.initialize_(this.$route.params.id);
        })
        .catch(e => {
          console.log("Error al cargar...");
        });
    },
    eliminar_horario(hid) {
      axios.post(window.hostname + '/api/admin/eliminar_horario', { horario_id: hid })
        .then(() => {
          alert("Horario eliminado");
          this.$router.push({ path: '/Profesional/' + this.$route.params.profesional_id });
        })
        .catch((e) => console.log("Error al cargar..."));
    },
    eliminar_profesional(hid) {
      axios.post(window.hostname + '/api/admin/eliminar_profesional', { profesional_id: hid })
        .then(response => {
          this.initialize_(this.$route.params.id);
        })
        .catch(e => {
          console.log("Error al cargar...");
        });
    },
    timeConvert(n) {
      const hours = Math.floor(n / 60);
      const minutes = Math.round(n % 60);
      return `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
    },
    initialize_(pid) {
      // Se verifica que el parámetro ID sea un número o string
      if (typeof (this.$route.params.id) === 'number' || typeof (this.$route.params.id) === 'string') {
        this.loaded = false;
        axios.post(window.hostname + '/api/admin/init_modificar_horario_pro', { id: pid })
          .then((response) => {
            this.loaded = true;
            const horario = response.data.horario;

            // Campos generales
            this.periodo = horario.intervalo;
            this.agregando_horario.inicio = horario.inicio;
            this.agregando_horario.termino = horario.termino;
            this.anticipacion = horario.anticipacion;
            this.prioridad = horario.prioridad;
            this.recargo_porcentaje = horario.recargo_porcentaje;
            this.recargo_suma = horario.recargo_suma;
            this.comunas_selected = horario.comunas;
            this.genera_bloqueo = horario.genera_bloqueo;

            // Campos "Solo se puede agendar hasta (días antes y hora):"
            this.anticipacion_fija_minima_dias = horario.anticipacion_fija_minima_dias;
            this.anticipacion_fija_minima_hora = horario.anticipacion_fija_minima_hora;

            // Campos "Solo se puede agendar desde (días antes y hora):"
            this.disponible_desde_dias = horario.disponible_desde_dias;
            this.disponible_desde_hora = horario.disponible_desde_hora;

            // Manejo de fechas de vigencia e inicio:
            if (horario.fecha_vigencia) {
              this.fecha_termino_dt = new Date(horario.fecha_vigencia).toISOString().split('T')[0];
              this.fecha_termino_checkbox = true;
            } else {
              this.fecha_termino_checkbox = false;
            }
            if (horario.fecha_inicio) {
              this.fecha_inicio_dt = new Date(horario.fecha_inicio).toISOString().split('T')[0];
              this.fecha_inicio_checkbox = true;
            } else {
              this.fecha_inicio_checkbox = false;
            }

            // Sección de días (repetición):
            // Se convierte el string de 7 caracteres (por ejemplo, "1010101") en un array de objetos
            // [{ value: 1 }, { value: 0 }, ...] para que los checkboxes funcionen correctamente.
            if (horario.repeticion && horario.repeticion.length === 7) {
              this.agregando_horario.repeticion = horario.repeticion
                .split('')
                .map(ch => ({ value: parseInt(ch) }));
            } else {
              // Si no viene correctamente, se reinicializa en 0
              this.agregando_horario.repeticion = [
                { value: 0 }, { value: 0 }, { value: 0 },
                { value: 0 }, { value: 0 }, { value: 0 },
                { value: 0 }
              ];
            }

            // Sección para categorías:
            // Se espera que "horario.categorias" sea un array de IDs.
            // Se genera el array "editando_categorias" usando la lista completa (this.categorias)
            // y marcando aquellas que están presentes en el horario.
            this.editando_categorias = this.categorias.map(cat => ({
              id: cat.id,
              nombre: cat.nombre,
              puede: (horario.categorias && horario.categorias.indexOf(cat.id) !== -1) ? 1 : 0
            }));

            // Sección para fechas específicas:
            // Si el horario tiene la opción activada, se asignan las fechas específicas (en formato "YYYY-MM-DD")
            if (horario.solo_fechas_especificas) {
              this.solo_fechas_especificas = true;
              this.chosenDates = horario.fechas_especificas || [];
            } else {
              this.solo_fechas_especificas = false;
            }
          })
          .catch(e => {
            this.loaded = true;
            console.log("Error al cargar...", e);
          });
      }
    },
    get_atencion_profesional_prestador(pid) {
      return axios.post(
        window.hostname + '/api/admin/init_modificar_pro',
        { id: pid }
      )
        .then(response => {
          this.profesional = response.data.profesional;

          // Filtra solo los prestadores que atiende este profesional
          this.atiende_prestadores = this.profesional.atiende_prestadores || [];

          // Asigna la propiedad activo basado en prestadores_activos
          this.atiende_prestadores.forEach(p => {
            p.activo = this.prestadores_activos.includes(p.id);
          });

        })
        .catch(error => {
          console.error("Error cargando profesional:", error);
          throw error;
        });
    },
    agregar_horario(agenda_id, inicio, termino, repeticion) {
      let error_msg = '';
      if (agenda_id == 0)
        error_msg = 'Por favor, ingrese una agenda. ';
      if (inicio === -1)
        error_msg += 'Por favor, ingrese una hora de inicio. ';
      if (termino === -1)
        error_msg += 'Por favor, ingrese una hora de término. ';
      if (inicio > termino)
        error_msg += 'La hora de inicio no puede ser mayor a la de término. ';

      let x = '';
      for (let i = 0; i < repeticion.length; i++) {
        x += repeticion[i].value.toString();
      }
      if (x === '0000000')
        error_msg += 'Debes especificar al menos un día. ';

      let cat = [];
      for (let j = 0; j < this.editando_categorias.length; j++) {
        if (this.editando_categorias[j].puede) {
          cat.push(this.editando_categorias[j].id);
        }
      }
      if (cat.length === 0)
        error_msg = 'Debes agregar al menos una categoría';
      if (this.comunas_selected.length === 0)
        error_msg = 'Debes agregar al menos una comuna';

      if (error_msg === '') {
        let data_ = {
          horario_id: this.$route.params.id,
          inicio: inicio,
          termino: termino,
          repeticion: x,
          categorias: cat,
          comunas: this.comunas_selected,
          anticipacion: this.anticipacion,
          prioridad: this.prioridad,
          recargo_porcentaje: this.recargo_porcentaje,
          recargo_suma: this.recargo_suma,
          intervalo: this.periodo,
          anticipacion_minima: this.anticipacion_minima,
          anticipacion_autoconfirmacion: this.anticipacion_autoconfirmacion,
          anticipacion_fija_minima_dias: this.anticipacion_fija_minima_dias,
          anticipacion_fija_minima_hora: this.anticipacion_fija_minima_hora,
          disponible_desde_dias: this.disponible_desde_dias,
          disponible_desde_hora: this.disponible_desde_hora,
          color: this.color,
          nombre: this.nombre,
          genera_bloqueo: this.genera_bloqueo,
        };

        if (this.fecha_inicio_checkbox && this.fecha_inicio_dt !== '')
          data_.fecha_inicio = this.fecha_inicio_dt;
        if (this.fecha_termino_checkbox && this.fecha_termino_dt !== '')
          data_.fecha_termino = this.fecha_termino_dt;

        // Agregamos la información de fechas específicas si está activado
        if (this.solo_fechas_especificas) {
          data_.solo_fechas_especificas = true;
          data_.fechas_especificas = this.chosenDates;
        } else {
          data_.solo_fechas_especificas = false;
        }

        axios.post(window.hostname + '/api/admin/modificar_horario', data_)
          .then(resp => {
            this.$notify({
              duration: 5000,
              title: 'Horario agregado',
              group: 'foo',
              text: '¡Se ha añadido el horario a la base de datos!',
              type: 'success'
            });
            this.initialize_(this.$route.params.id);
          })
          .catch(e => {
            this.$notify({
              duration: 5000,
              title: 'Error!',
              group: 'foo',
              text: e.response.data.message,
              type: 'error'
            });
          });
      } else {
        console.log("Error:", error_msg);
        this.$notify({
          duration: 5000,
          title: 'Error!',
          group: 'foo',
          text: error_msg,
          type: 'error'
        });
      }
    },
    get_atencion_horario_prestador() {
      const horario_id = this.$route.params.id;
      axios.get(window.hostname + `/api/admin/horarios/${horario_id}/atencion_prestador`)
        .then(resp => {
          this.prestadores = resp.data.prestadores;
          this.prestadores_activos = resp.data.prestadores_activos;
          this.prestadores.forEach(prestador => {
            prestador.activo = this.prestadores_activos.includes(prestador.id);
          });
        })
        .catch(e => {
          this.$notify({
            duration: 5000,
            title: 'Error!',
            text: e.response.data.message,
            type: 'error'
          });
        });
    },
    post_atencion_horario_prestador() {
      const horario_id = this.$route.params.id;
      let prestadores_activos = [];
      this.prestadores.forEach(prestador => {
        if (prestador.activo) {
          prestadores_activos.push(prestador.id);
        }
      });
      this.prestadores_activos = prestadores_activos;
      axios.post(window.hostname + `/api/admin/horarios/${horario_id}/atencion_prestador`, { prestadores_activos })
        .then(resp => {
          this.$notify({
            duration: 5000,
            title: 'Prestadores actualizados',
            text: '¡Se han realizado los cambios con éxito!',
            type: 'success'
          });
          this.get_atencion_horario_prestador();
        })
        .then(() => alert('Se han realizado los cambios con éxito!'))
        .catch(e => {
          this.$notify({
            duration: 5000,
            title: 'Error!',
            text: e.response.data.message,
            type: 'error'
          });
          alert('Ha ocurrido un error al actualizar los prestadores');
        });
    },

    removeDate(index) {
      this.chosenDates.splice(index, 1);
    },

    clearAllDates() {
      this.chosenDates = [];
    },

    removeComuna(comunaId) {
      const index = this.comunas_selected.indexOf(comunaId);
      if (index > -1) {
        this.comunas_selected.splice(index, 1);
      }
    },
  },
  computed: {
    ...mapGetters([
      'comunas',
      'categorias_usadas',
      'prestador',
      'categorias',
      'regiones',
      'prestaciones',
      'tipos',
      'admin_datos',
      'examenes'
    ]),
    prestadores_filtrados() {
      // Mostrar solo los que están en atiende_prestadores
      const idsPermitidos = this.atiende_prestadores.map(ap => ap.id);
      return this.prestadores.filter(p => idsPermitidos.includes(p.id));
    }
  },
  watch: {
    comunas_buscadas(val) {
      this.resultado_fuse_comuna = this.fComunas.search(val);
    },
  },
  mounted() {
    this.fComunas = new Fuse(this.comunas, { keys: ['Nombre'] });
    this.get_atencion_horario_prestador();
  }
}
</script>



<style scoped>
.column-right {
  background-color: var(--background-primary);
  padding-top: 0px;
  padding-left: 275px;
  width: 100%;
  min-height: 100vh;
}

.professionals-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  padding: 2rem;
}

/* Improved Grid System */
.schedule-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 2rem;
}

.schedule-column {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .column-right {
    padding-left: 0;
  }
  
  .schedule-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}

@media (max-width: 768px) {
  .main-container,
  .articulo-principal {
    margin: 1rem;
    padding: 1.5rem;
  }
  
  .time-settings-grid {
    grid-template-columns: 1fr;
  }
}

/* Enhanced Form Styles */
.form-group {
  margin-bottom: 1rem;
}

.form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #374151;
}

.form-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  background-color: #f8fafc;
  transition: all 0.2s ease;
  font-size: 0.875rem;
}

.form-input:focus {
  outline: none;
  border-color: #3b82f6;
  background-color: white;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-select {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  background-color: #f8fafc;
  font-size: 0.875rem;
}

.form-select.small {
  max-width: 150px;
}

/* Improved Alias Section */
.alias-section {
  margin-bottom: 2rem;
}

.alias-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.alias-item {
  display: flex;
  justify-content: between;
  align-items: center;
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.alias-item:hover {
  border-color: #3b82f6;
}

.alias-content {
  flex: 1;
}

.alias-name {
  font-weight: 600;
  color: #1f2937;
}

.alias-description {
  color: #6b7280;
  margin-left: 0.5rem;
}

.alias-delete-btn {
  background: none;
  border: none;
  color: #ef4444;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  transition: background-color 0.2s ease;
}

.alias-delete-btn:hover {
  background-color: #fef2f2;
}

.add-alias-btn {
  margin-top: 1rem;
}

/* Enhanced Setting Groups */
.setting-group {
  margin-bottom: 1.5rem;
}

.setting-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #374151;
  position: relative;
}

/* Improved Time Settings */
.time-settings-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.time-range {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

/* Enhanced Days Selection */
.days-section {
  margin-bottom: 1.5rem;
}

.days-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.day-item {
  text-align: center;
}

.day-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.day-label:hover {
  background-color: #f8fafc;
}

.day-checkbox {
  margin: 0;
}

.day-text {
  font-size: 0.75rem;
  font-weight: 600;
  color: #374151;
}

/* Improved Checkbox Styles */
.checkbox-settings {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  padding: 0.5rem 0;
}

.checkbox-label.large {
  font-size: 1rem;
  font-weight: 600;
}

.checkbox-label.small {
  justify-content: center;
}

.checkbox-input {
  margin: 0;
}

.checkbox-text {
  font-weight: 500;
}

.checkbox-custom {
  width: 18px;
  height: 18px;
  border: 2px solid #d1d5db;
  border-radius: 4px;
  display: inline-block;
  position: relative;
}

.checkbox-input:checked + .checkbox-custom {
  background-color: #3b82f6;
  border-color: #3b82f6;
}

.checkbox-input:checked + .checkbox-custom::after {
  content: '✓';
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  font-weight: bold;
}

/* Enhanced Specific Dates Section */
.specific-dates-section {
  position: relative;
}


.dates-controls {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.date-picker-btn {
  margin: 0;
}

.clear-dates-btn {
  background: white;
  border: 2px solid #e2e8f0;
  color: #6b7280;
}

.clear-dates-btn:hover {
  background: #f8fafc;
  border-color: #d1d5db;
}

.dates-header {
  margin-bottom: 1rem;
}

.dates-header small {
  color: #6b7280;
  margin-left: 0.5rem;
}

.selected-dates-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.date-badge {
  background-color: #e1f5fe;
  border: 2px solid #81d4fa;
  color: #0277bd;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.date-badge.interactive {
  cursor: pointer;
  transition: all 0.2s ease;
}

.date-badge.interactive:hover {
  background-color: #ffebee;
  border-color: #ef9a9a;
  color: #c62828;
  transform: scale(1.05);
}

.remove-date {
  font-weight: bold;
  font-size: 1.125rem;
  margin-left: 0.25rem;
}

.no-dates-message {
  text-align: center;
  padding: 2rem;
  color: #6b7280;
  background: white;
  border-radius: 8px;
  border: 2px dashed #e2e8f0;
}

/* Improved Search and Selected Items */
.search-container {
  position: relative;
}

.search-input {
  width: 100%;
}

.search-results {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  z-index: 10;
  max-height: 200px;
  overflow-y: auto;
}

.search-result-item {
  padding: 0.75rem 1rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.2s ease;
}

.search-result-item:hover {
  background-color: #f8fafc;
}

.result-text {
  flex: 1;
}

.result-check {
  color: #10b981;
}

.selected-items {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1rem;
}

.selected-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.75rem;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
}

.remove-item-btn {
  background: none;
  border: none;
  color: #ef4444;
  cursor: pointer;
  font-size: 1.125rem;
  padding: 0.25rem;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.remove-item-btn:hover {
  background-color: #fef2f2;
}

/* Enhanced Tables */
.table-container {
  overflow-x: auto;
}

.schedule-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.schedule-table th {
  background: #f8fafc;
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
  border-bottom: 1px solid #e2e8f0;
}

.schedule-table td {
  padding: 1rem;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

.schedule-table tr:last-child td {
  border-bottom: none;
}

.schedule-table tr:hover {
  background-color: #f8fafc;
}

/* Improved Action Buttons */
.action-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
  flex-wrap: wrap;
}

.save-btn, .delete-btn {
  min-width: 160px;
}

/* Enhanced Section Styles */
.page-title {
  margin-bottom: 2rem;
  color: #1f2937;
}

.section-title {
  margin-bottom: 1.5rem;
  color: #1f2937;
  display: flex;
  align-items: center;
}

.prestadores-section {
  margin-top: 2rem;
}

.prestadores-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.prestadores-actions {
  text-align: center;
}

/* Improved Loader */
.loader-container {
  height: calc(100vh - 140px);
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Enhanced Main Containers */
.main-container {
  background: white;
  border-radius: 16px;
  margin: 2rem;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

.articulo-principal {
  background: white;
  border-radius: 16px;
  margin: 2rem;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

.boxy {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

/* Enhanced Info Icons */
.info-icon-container {
  display: inline-block;
  margin-left: 0.5rem;
  position: relative;
}

.info-icon {
  cursor: pointer;
  font-size: 1rem;
}

.info-icon-container-popup {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  color: white;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 0.875rem;
  width: 200px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  z-index: 20;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  pointer-events: none;
}

.info-icon-container:hover .info-icon-container-popup {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(-5px);
}

/* Button Enhancements */
.btn {
  display: inline-flex;
  align-items: center;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
}

.btn-success {
  background-color: #10b981;
  color: white;
}

.btn-success:hover {
  background-color: #059669;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.btn-danger {
  background-color: #ef4444;
  color: white;
}

.btn-danger:hover {
  background-color: #dc2626;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.btn-outline {
  background: white;
  border: 2px solid #e2e8f0;
  color: #6b7280;
}

.btn-outline:hover {
  background: #f8fafc;
  border-color: #d1d5db;
}
</style>